import type { KivraCSSObject } from "./styled/styled";

/**
 * Hides content visually but not for screen readers.
 */
export const visuallyHiddenStyle: KivraCSSObject = {
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: "1px",
  overflow: "hidden",
  position: "absolute",
  whiteSpace: "nowrap",
  width: "1px",
};

/**
 * Adds outline styling for .keyBoardFocus selector.
 */
export const getFocusStyle = (
  additionalStyles?: KivraCSSObject,
): KivraCSSObject => ({
  "&:focus": {
    outline: "none",
  },
  ".keyboardFocus &:focus": {
    outline:
      `${defaultFocusStyles.outlineWidth} ${defaultFocusStyles.outlineStyle} ${defaultFocusStyles.outlineColor}`,
    outlineOffset: defaultFocusStyles.outlineOffset,
    ...additionalStyles,
  },
});

export const defaultFocusStyles: Pick<
  KivraCSSObject,
  "outlineWidth" | "outlineStyle" | "outlineColor" | "outlineOffset"
> = {
  outlineWidth: "2px",
  outlineStyle: "solid",
  outlineColor: "$focus-border",
  outlineOffset: "4px",
};
